import React from 'react';
import moment from "moment";
import Switch from '@material-ui/core/Switch';
import Chip from '@material-ui/core/Chip';
import PPMobileCardView from '../../../components/PPMobileCardView';

const GroupMobile = ({data,onEdit,onDelete,handleIsActiveChange}) => {
    // Same as the desktop Active column of the group table
    const active = data.groupBatches.some(e => e.isActive) ?
        <Switch
            checked={data.isActive}
            onChange={handleIsActiveChange}
            color="primary"
            size="small"
            inputProps={{ 'aria-label': 'primary checkbox' }}
        />
        :
        <Chip className="pp-pill" label="Deactivated" style={{ backgroundColor: '#f44336', color: 'white' }} />;

    const rows = [
        { label: 'Active', value: active, inHeader: true, hideLabel: true },
        { label: 'Purchase Date', value: moment(data.purchaseDate).format("DD-MM-YYYY") },
        {
            label: 'Sub Batches',
            value: <div className="flex-gap-6" style={{ flexWrap: 'wrap' }}>
                {data.groupBatches.map(batch =>
                    <Chip key={batch.id} className="pp-pill" label={`${batch.name} (${batch.shedName})`} style={{ background: "#E8F7F4" }} />
                )}
            </div>,
            fullWidth: true,
        },
    ];

    const menuItems = [
        { label: 'Edit', onClick: onEdit },
        { label: 'Delete', onClick: onDelete },
    ];

    return (
        <PPMobileCardView
            title={data.name}
            rows={rows}
            menuItems={menuItems}
        />
    );
};

export default GroupMobile;
